import {atom} from 'jotai'
import { IOwnerViewModel } from './atomConfig';

const ownerAtom = atom<IOwnerViewModel>({} as IOwnerViewModel);
ownerAtom.debugLabel = 'ownerAtom';

export default ownerAtom;